import {menuMainItems} from "~~/route/route.config";

export const useI18nRoute = () => {
    const { locale } = useI18n();
    const routeConfig = menuMainItems;

    const getI18nRoute = (identifier: string): string => {
        return routeConfig.find(i => i.identifier === identifier)?.path?.[locale.value] || '#';
    };

    return {
        getI18nRoute
    }
}